/**
 * Remotion Image Overlay Component
 *
 * Renders images with objectFit support - replaces Fabric.js image rendering.
 * Uses Remotion's <Img> for optimized loading in render mode.
 */

import React from 'react';
import { Img } from 'remotion';
import { ImageOverlayData } from '../types';

interface ImageOverlayProps {
  overlay: ImageOverlayData;
  containerWidth: number;
  containerHeight: number;
}

export const ImageOverlay: React.FC<ImageOverlayProps> = ({
  overlay,
  containerWidth,
  containerHeight,
}) => {
  const {
    src,
    position,
    width,
    height,
    rotation = 0,
    zIndex = 0,
    opacity = 100,
    objectFit = 'cover',
    borderRadius = 0,
  } = overlay;

  // Convert percentage dimensions to pixels
  const left = (position.x / 100) * containerWidth;
  const top = (position.y / 100) * containerHeight;
  const widthPx = (width / 100) * containerWidth;
  const heightPx = height ? (height / 100) * containerHeight : widthPx; // Default to square if no height

  return (
    <div
      style={{
        position: 'absolute',
        left,
        top,
        width: widthPx,
        height: heightPx,
        transform: rotation ? `rotate(${rotation}deg)` : undefined,
        transformOrigin: 'top left',
        zIndex,
        opacity: opacity / 100,
        overflow: 'hidden',
        borderRadius,
      }}
    >
      <Img
        src={src}
        style={{
          width: '100%',
          height: '100%',
          objectFit,
        }}
      />
    </div>
  );
};

export default ImageOverlay;
